import { render, staticRenderFns } from "./BasePos.vue?vue&type=template&id=73ec1a45"
import script from "./BasePos.vue?vue&type=script&lang=js"
export * from "./BasePos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports